const faq = {
  safety: {
    title: 'Безопасность',
    issues: [
      {
        title: 'Почему VK-BO$$ считается самым безопасным?',
        description:
          'VK-BO$$ единственный сервис по автоматизации личной страницы, которые не требует вашего пароля. Сервисов на рынке сейчас достаточно, н овсе запрашивают ваш логин и пароль и много раз были случаи, когда эти данные были использованы не по назначению. Отдавая свой пароль Вы также рискуете потерять свою страницу или получить БАН. Наш сервис не берёт паролей и работает по другим технологиям, что позволяет обеспечивать пользователю максимальную из возможных безопасность.',
      },
      {
        title: 'Могут ли забанить мою страницу?',
        description:
          'На сегодняшний день VK-BO$$ является самым безопасным сервисом. За 4 года работы не было случаев полной блокировки у наших пользователей. Во вконтакте есть ряд правил, которые нужно соблюдать и в случаи их нарушения, вас могут заморозить на сутки. Чтобы этого не случилось, нужно пользоваться нашими рекомендациями.\nСам факт использования сервиса не ведет к заморозкам и блокировкам, так как его алгоритмы делают действия как будто вашими руками. Единственная причина временно заморозки может быть только, если пользователи начнут жаловаться на ваши сообщения или страницу. такое может быть .если вы не соблюдаете наши рекомендации или просто не повезло. Сейчас в Вк есть очень неуклюжие алгоритмы, что в заморозку могут попасть любые люди даже за слова Привет или обычный комментарий на посте. И если написать в тех. поддержку вк с вопросом о блокировке то в 90% случаях извиняются за ошибку и размораживают страницу.',
      },
    ],
  },
  purchase: {
    title: 'Покупка',
    issues: [
      {
        title: 'Можно ли купить за электронную валюту?',
        description:
          'Покупки в сервисе возможно только через карты VISA, Maestro, MasterCard, МИР, Яндекс деньги, Киви и переводом для организации. Платежи поддерживаются со всех стран.',
      },
      {
        title: 'Купить на несколько аккаунтов',
        description:
          'Если у вас несколько аккаунтов, по покупать нужно на каждый в отдельности. На данный момент в сервисе не поддерживается мульт аккаунты, но эта возможность в разработки. Для покупки на несколько аккаунтов нужно авторизоваться в нужном аккаунте вк, зайти в магазин расширения и сделать покупку. При при авторизации в вк в расширении нужно пройти авторизацию повторно, для загрузки настроек нужного аккаунта.',
      },
      {
        title: 'Как восстановить доступ',
        description:
          'Все покупки привязываются к Вашему аккаунту ВК. Если вы хотите поставить сервис на другом компьютере или месте, достаточно установить расширение в браузер и авторизоваться под вашей страницей вк.',
      },
    ],
  },
};

export default faq;
